export function getColorPercent(color, percent = 50) {
  const parsedColor = color.substring(1)
  let num = parseInt(parsedColor, 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    // eslint-disable-next-line no-mixed-operators
    B = (num >> 8 & 0x00FF) + amt,
    G = (num & 0x0000FF) + amt

  return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16)
    .slice(1)
}


export function getBackgroundGradient(color) {
  const secondaryColor = getColorPercent(color, 50)
  return `linear-gradient(45deg, ${color} 30%, ${secondaryColor} 90%)`
}
